export const LOADER_SANCIONES_DOCS          =   'LOADER_SANCIONES_DOCS';
export const LOADER_SANCIONES_DOC           =   'LOADER_SANCIONES_DOC';
export const SAVE_LOADER_SANCIONES_DOC      =   'SAVE_LOADER_SANCIONES_DOC';
export const GET_SANCIONES_DOCS             =   'GET_SANCIONES_DOCS';
export const GET_SANCIONES_DOC              =   'GET_SANCIONES_DOC';
export const FAILD_SANCIONES_DOCS           =   'FAILD_SANCIONES_DOCS';
export const FAILD_SANCIONES_DOC            =   'FAILD_SANCIONES_DOC';
export const FORM_SANCIONES_DOC_FAILD       =   'FORM_SANCIONES_DOC_FAILD';